import { SFC } from 'react'

import { PermissionCheck }                               from '../../project-utils/permissions'
import withAccountType, { InjectedWithAccountTypeProps } from '../hocs/withAccountType'

interface PermissionProps {
  check: PermissionCheck | PermissionCheck []
  children: any
  invert?: boolean,
}

type Props =
  PermissionProps
  & InjectedWithAccountTypeProps

const PermissionGuard: SFC<Props> = props => {
  const {
    children,
    check,
    invert,
    accountType,
  } = props

  let passed

  if (typeof check === 'function') {
    passed = check(accountType)
  } else {
    passed = check.every(checkFunc => checkFunc(accountType))
  }

  const shouldRender = invert ? !passed : passed

  if (!shouldRender) return null

  if (typeof children === 'function') {
    return children()
  }

  return children
}

export default withAccountType(PermissionGuard)



// WEBPACK FOOTER //
// ./src/components/atoms/PermissionGuard.tsx